import request from '@/utils/request'

// 查询列表
export function apiScpMrpHorizontalSummaryList (data) {
  return request({
    url: '/scp/scpMrpHorizontalSummary/list',
    method: 'post',
    data: data
  })
}

// 数据收集时间、叫料计算完成时间
export function apiScpMrpPlansCallMaterialPlanExecutionTime (query) {
  return request({
    url: '/scp/scpMrpPlans/callMaterialPlanExecutionTime',
    method: 'get',
    params: query
  })
}

// 动态表头
export function apiScpMrpHorizontalDatesDateDisplayList (query) {
  return request({
    url: '/scp/scpMrpHorizontalDates/dateDisplayList',
    method: 'get',
    params: query
  })
}

// 计划版本
export function apiScpMrpPlansPlanVersionBox (query) {
  return request({
    url: '/scp/scpMrpPlans/planVersionBox',
    method: 'get',
    params: query
  })
}

// 物料类别
export function apiScpMrpCategoryCodeCategoryBox (query) {
  return request({
    url: '/scp/scpMrpCategoryCode/categoryBox',
    method: 'get',
    params: query
  })
}

// 保存筛选方案
export function apiScpScreeningSchemeSaveScheme (data) {
  return request({
    url: '/scp/scpScreeningScheme/saveScheme',
    method: 'post',
    data: data
  })
}

// 设置筛选方案-删除
export function apiScpScreeningSchemeDeleteScheme (id) {
  return request({
    url: `/scp/scpScreeningScheme/deleteScheme/${id}`,
    method: 'delete'
  })
}

// 设置筛选方案-修改
export function apiScpScreeningSchemeUpdateScheme (data) {
  return request({
    url: '/scp/scpScreeningScheme/updateScheme',
    method: 'post',
    data: data
  })
}

// 筛选方案列表
export function apiScpScreeningSchemeSearchAllScheme (query) {
  return request({
    url: '/scp/scpScreeningScheme/searchAllScheme',
    method: 'get',
    params: query
  })
}

// 发布
export function apiScpMrpHorizontalSummaryRelease (data) {
  return request({
    url: '/scp/scpMrpHorizontalSummary/release',
    method: 'put',
    data: data
  })
}

// 整版发布
export function apiScpMrpHorizontalSummaryFullVersionRelease (data) {
  return request({
    url: '/scp/scpMrpHorizontalSummary/fullVersionRelease',
    method: 'put',
    data: data
  })
}

// 列表-行保存
export function apiScpMrpHorizontalQuantitiesUpdate (data) {
  return request({
    url: '/scp/scpMrpHorizontalQuantities',
    method: 'put',
    data: data
  })
}
